import { SignDto } from "@core/crypto-sign.service";
import { createAction } from "@ngrx/store";

export const setPending = createAction(
	"[App] Set Pending",
	(isPending: boolean): { isPending: boolean } => ({ isPending })
);

export const setFormPending = createAction(
	"[App] Set Form Pending",
	(isPending: boolean): { isPending: boolean } => ({ isPending })
);

export const setPopupPending = createAction(
	"[App] Set Popup Pending",
	(isPending: boolean): { isPending: boolean } => ({ isPending })
);

export const setRouterPending = createAction(
	"[App] Set Router Pending",
	(isPending: boolean): { isPending: boolean } => ({ isPending })
);

export const setTablePending = createAction(
	"[App] Set Table Pending",
	(isPending: boolean): { isPending: boolean } => ({ isPending })
);

export const openInactionPopup = createAction(
	"[App] Open Inaction Popup"
);

export const checkOverlay = createAction(
	"[App] Check Overlay",
	(status: "OPEN" | "CLOSE"): { status: "OPEN" | "CLOSE" } => ({ status })
);

export const checkMobileEds = createAction(
	"[App] Check Mobile Eds",
	(signDto: SignDto): { signDto: SignDto } => ({ signDto })
);

export const setRefFormPending = createAction(
	"[App] Set Ref Form Pending",
	(isPending: boolean, message?: string): { isPending: boolean, message?: string } => ({ isPending, message })
);
